export default __webpack_public_path__ + "static/media/arrow_back.ef637622.svg";